import { atom } from "jotai";

export type QuizAtom = {
  quizId: string;
  tag: string;
  title: string;
  image: string;
};

export const selectQuizAtom = atom<QuizAtom | null>(null);
